module.exports = __webpack_public_path__ + "static/img/banner_desktop5.70c3df33.jpg";